// --- START OF FILE PlusAnualStyle.js ---

import styled from "styled-components";

export const PLUSContainer = styled.div`
    width: 100%;
    min-height: 100vh;
    padding: 40px;
    box-sizing: border-box;
    background-image: url('/textura.jpg');
    background-size: cover;
    background-attachment: fixed;
`;

export const ContentBox = styled.div`
    background: rgba(30, 30, 30, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 8px;
    padding: 30px 40px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    z-index: 1;
`;

export const Header = styled.div`
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    
    h1 {
        margin: 0;
        color: #E6AA3A;
        font-size: 28px;
    }
`;

export const Step = styled.div`
    margin-bottom: 30px;
    
    h4 {
        margin: 0 0 15px 0;
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        opacity: 0.9;
    }
`;

export const ClientSearch = styled.div`
    .inputBoxFilter {
        display: flex;
    }

    input {
        flex-grow: 1;
        height: 45px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0,0,0,0.3);
        padding: 0 20px;
        color: #fff;
        border-radius: 6px;
        font-size: 16px;
        &:focus { outline: none; border-color: #E6AA3A; }
    }
`;

export const ButtonSearch = styled.div`
    margin-top: 15px;
    button {
        width: 100%;
        height: 45px;
        border: none;
        background: #E6AA3A;
        color: #111;
        cursor: pointer;
        border-radius: 6px;
        font-weight: 600;
        font-size: 16px;
        transition: background-color 0.2s ease-in-out;

        &:hover {
            background-color: #f7b74a;
        }
    }
`;

export const SearchedClients = styled.div`
    margin-top: 20px;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 6px;
    overflow: hidden;

    .columns, .row, .rowSelected {
        display: grid;
        grid-template-columns: 1fr 3fr 2fr 2fr;
        padding: 12px 15px;
        color: #fff;
        align-items: center;
        text-align: left;
        gap: 10px;
    }

    .columns {
        font-weight: bold;
        background: rgba(0,0,0,0.2);
        border-bottom: 2px solid #E6AA3A;
    }

    .tabelona {
        max-height: 250px;
        overflow-y: auto;
    }

    .row {
        cursor: pointer;
        border-bottom: 1px solid rgba(255,255,255,0.1);
        transition: background-color 0.2s ease-in-out;
        &:hover { background: rgba(230, 170, 58, 0.1); }
    }
    
    .rowSelected {
        background: #E6AA3A;
        color: #111;
        font-weight: bold;
        grid-template-columns: 1fr 3fr 2fr 2fr auto;
        
        button {
            background: transparent;
            border: none;
            color: #111;
            cursor: pointer;
            font-size: 16px;
        }
    }
`;

export const QuandoDeseja = styled.div`
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    
    h4 {
        margin: 0 0 20px 0;
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        opacity: 0.9;
        text-align: center;
    }

    .form-container {
        display: flex;
        flex-direction: column;
        gap: 20px;
        max-width: 400px;
        margin: 0 auto;
    }
    
    .input-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    label {
        color: #ccc;
        font-weight: 500;
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    input {
        height: 48px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        background: rgba(0,0,0,0.3);
        color: #fff;
        font-size: 18px;
        border-radius: 6px;
        padding: 0 15px;
        text-align: center;
        &:focus { outline: none; border-color: #E6AA3A; }
    }

    .submit-button {
        width: 100%;
        border: none;
        height: 48px;
        background-color: #27ae60;
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        cursor: pointer;
        border-radius: 6px;
        transition: all 0.2s ease-in-out;

        &:hover {
            background-color: #2ecc71;
        }
    }
`;